import * as React from "react";

import "./index.scss";

export default function ManagerFootballTeamCard(props) {
	const {element} = props;

	return (
		<div className="manager-team-card-container">
			<img
				className="manager-team-card-icon"
				src={require("@/assets/images/manager/club.png")}
				alt=""
			/>
			<span className="manager-team-card-name">
				{element?.name || element?.playerCategory?.name}
			</span>
			{element?.season?.name && (
				<span className="manager-team-card-season">{element.season.name}</span>
			)}
		</div>
	);
}
